import React from 'react';
import { useTranslation } from 'react-i18next';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FormGroup } from 'react-bootstrap';
import { BorderStyleConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/BorderStyleConfig';
import { BorderConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/BorderConfig';
import { BorderColorConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/BorderColorConfig';
import { BoldConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/BoldConfig';
import { AlignmentConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/AlignmentConfig';
import { ColorConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/ColorConfig';
import { FontSizeConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/htmlFontSizeConfig';

export function HtmlSetting({ obj, onChange, handleOtherConfig, handleBorderStyle, handleFontSize }) {
  const { t } = useTranslation('common');

  return (
    <>
      <FormGroup>
        <div className="common-input-control">
          <p className="f-16 text-bold field-name">{t('DPP.CONTROL.HTML.HTML_TITLE')}</p>
          <input
            type="text"
            className="form-control"
            value={obj?.htmlTitle}
            placeholder={t('DPP.CONTROL.HTML.ENTER_HTML_TITLE')}
            onChange={(e) => onChange(e.target.value, 'htmlTitle')}
            maxLength="40"
          />
          <div className="d-flex">
            <AlignmentConfig obj={obj} handleAlignment={handleOtherConfig} dataName="htmlTitleAlign" />
            <ColorConfig obj={obj} handleColor={handleOtherConfig} dataName="htmlTitleColor" />
            <BoldConfig obj={obj} handleBold={handleOtherConfig} dataName="htmlTitleBold" />
          </div>
          <FontSizeConfig obj={obj} handleFontSize={handleFontSize} dataName="htmlTitleFontSize" />
        </div>
      </FormGroup>
      <FormGroup>
        <div className="common-input-control mb-0">
          <p className="field-name">{t('DPP.CONTROL.PRODUCTJOURNEY.SUB_HEADER_TITLE')}</p>
          <input
            type="text"
            className="form-control"
            value={obj?.subHeaderTitle}
            placeholder={t('DPP.CONTROL.PRODUCTJOURNEY.ENTER_SUBHEADER_TITLE')}
            onChange={(e) => onChange(e.target.value, 'subHeaderTitle')}
            maxLength="40"
          />
        </div>
        <div className="d-flex">
          <AlignmentConfig obj={obj} handleAlignment={handleOtherConfig} dataName="subHeaderAlign" />
          <ColorConfig obj={obj} handleColor={handleOtherConfig} dataName="subHeaderColor" />
          <BoldConfig obj={obj} handleBold={handleOtherConfig} dataName="subHeaderBold" />
        </div>
      </FormGroup>

      <FormGroup>
        <CKEditor
          editor={ClassicEditor}
          data={obj?.ckeditorData || ''}
          config={{
            height: 400,
            toolbar: [
              'lineHeight',
              'heading',
              '|',
              'bold',
              'italic',
              'underline',
              'strikethrough',
              '|',
              'link',
              'bulletedList',
              'numberedList',
              '|',
              'insertTable', // Add "insertTable" button
              '|',
              'undo',
              'redo',
              'pageBreak',
              'alignment',
              '|',
              'fontFamily',
              'fontSize',
              'fontColor',
              'fontBackgroundColor',
              '|',
              'removeFormat',
              'horizontalLine',
            ],
          }}
          onChange={(_event, editor) => {
            const newData = editor.getData();
            onChange(newData, 'ckeditorData');
          }}
          onReady={(editor) => {
            editor.setData(obj?.ckeditorData || '');
          }}
        />
      </FormGroup>
      <BorderConfig obj={obj} handleBorder={handleOtherConfig} />

      <div className="d-flex">
        <div className="mr-4">
          <span className="f-16 mb-2 text-bold">{t('DPP.CONTROL.HTML.BORDER')}</span>
          <BorderStyleConfig obj={obj} handleBorderStyle={handleBorderStyle} />
        </div>
        <div>
          <BorderColorConfig obj={obj} paddingTopZero handleBorder={handleOtherConfig} />
        </div>
      </div>
    </>
  );
}

export default HtmlSetting;
